import { IngredientsListItem } from "@Types/recipes-detail-page";
import { getCtData } from "./HomePageHelpers";

interface IngredientItemProps extends IngredientsListItem {
  addToBasketText: string;
}

const getItemData = async (ctProductSku: string) =>
  await getCtData(ctProductSku);
export const recipeItemToCTItemTransformer = async (
  product: IngredientItemProps
) => {
  const { isWfProduct, ctProductSku } = product;
  if (!isWfProduct || !ctProductSku) return;
  const ctData = getItemData(ctProductSku);
  return await ctData;
};
